/* eslint-disable import/prefer-default-export */
import moduleRegistry from '../module-registry/module-registry';
import { isClickOrEnter } from '../utils/utils';

const config = {
    selectors: {
        root: '.overlay',
        backdrop: '.overlay__backdrop',
        closeBtn: '.overlay__close-btn',
        backBtn: '.overlay__back-btn',
        content: '.overlay__content',
        openTrigger: '[data-overlay-open]',
        textAreaBtn: '.cta-button',
        thanks: '.contact-accordion__thanks',
        wrapper: '.overlay__wrapper',
        header: '.overlay__header',
        searchInput: '.search-bar__text-input',
        fullScreenGalleryBtn: '.gallery__open-btn',
        fullScreenGalleryBtnClose: '.gallery__close-btn',

    },
    classNames: {
        bodyNoScroll: 'body--no-scroll',
        overlayVisible: 'overlay--visible',
        sticky: 'overlay--sticky-header',
        stickyHeader: 'overlay__header--sticky',
        fullScreen: 'overlay--full-screen',
    },
};

export class Overlay {
    constructor($rootElement) {
        this._$rootElement = $rootElement;
        this._elements = null;
    }

    init() {
        this._elements = this._getDomElements();
        this._addEventListeners();

        if(!$('.overlay--tab').hasClass('overlayVisible')) {
            $('.overlay--tab .sticky-section__content').removeClass('sticky-section__content--visible')
            $('.overlay--tab .sticky-section__bar-item').removeClass('sticky-section__bar-item--active')
        }

        
    }
    static initLater($rootElement) {
        const $elements = {
            $html: $('html'),
            $content: $rootElement.find(config.selectors.content),
            $backdrop: $rootElement.find(config.selectors.backdrop),
            $closeBtn: $rootElement.find(config.selectors.closeBtn),
            $wrapper: $rootElement.find(config.selectors.wrapper),
            $header: $rootElement.find(config.selectors.header),
            $openTrigger: $(config.selectors.openTrigger),
        };

        $elements.$backdrop.on('click', () => {
            $rootElement.removeClass(config.classNames.overlayVisible);
            const videoSettings = $rootElement.find('.video-js');
            videoSettings.each((i, el) => {
                if (el.player) {
                    el.player.pause();
                }
            });
            $elements.$html.removeClass('body--no-scroll');
        });

       $elements.$closeBtn.on('click', () => {
            $rootElement.removeClass(config.classNames.overlayVisible);
            const videoSettings = $rootElement.find('.video-js');
            videoSettings.each((i, el) => {
                if (el.player) {
                    el.player.pause();
                }
            });
            $elements.$html.removeClass('body--no-scroll');
        });

         // eslint-disable-next-line func-names
         $elements.$openTrigger.on('click keydown', function (e) {
            // eslint-disable-next-line no-console
            if (!isClickOrEnter(e)) {
                return;
            }

            const dataId = $(this).data('overlay-open');
            $(`[data-overlay-id="${dataId}"]`).addClass(config.classNames.overlayVisible);
            $elements.$html.addClass('body--no-scroll');
            if (dataId === 'search') {
                if ($(config.selectors.searchInput)) {
                    $(config.selectors.searchInput).focus();
                    $(config.selectors.searchInput).val('');
                }
            }
        });

        if ($rootElement.hasClass(config.classNames.sticky)) {
            $elements.$wrapper.on('scroll', () => {
                if ($elements.$wrapper[0].scrollTop === 0) {
                    $elements.$header.removeClass(config.classNames.stickyHeader);
                } else {
                    $elements.$header.addClass(config.classNames.stickyHeader);
                }
            });
        }
    }

    _getDomElements() {
        const thanks = this._$rootElement.find(config.selectors.thanks);
        return {
            $html: $('html'),
            $content: this._$rootElement.find(config.selectors.content),
            $backdrop: this._$rootElement.find(config.selectors.backdrop),
            $closeBtn: this._$rootElement.find(config.selectors.closeBtn),
            $backBtn: this._$rootElement.find(config.selectors.backBtn),
            $wrapper: this._$rootElement.find(config.selectors.wrapper),
            $header: this._$rootElement.find(config.selectors.header),
            $fullScreenGalleryBtn: this._$rootElement.find(config.selectors.fullScreenGalleryBtn),
            // eslint-disable-next-line max-len
            $fullScreenGalleryBtnClose: this._$rootElement.find(config.selectors.fullScreenGalleryBtnClose),
            $openTrigger: $(config.selectors.openTrigger),
            $thanksBtn: thanks.find(config.selectors.textAreaBtn),
            $textAreaBtn: this._$rootElement.find(config.selectors.textAreaBtn),
        };
    }

    _addEventListeners() {
        const _this = this;
        
        // eslint-disable-next-line no-unused-vars
       
        this._elements.$backdrop.on('click', () => {
            this._$rootElement.removeClass(config.classNames.overlayVisible);
            const videoSettings = this._$rootElement.find('.video-js');
            videoSettings.each((i, el) => {
                if (el.player) {
                    el.player.pause();
                }
            });
            $('html').removeClass('body--no-scroll');
        });

        this._elements.$closeBtn.on('click', () => {
            this._$rootElement.removeClass(config.classNames.overlayVisible);
            const videoSettings = this._$rootElement.find('.video-js');
            videoSettings.each((i, el) => {
                if (el.player) {
                    el.player.pause();
                }
            });
            $('html').removeClass('body--no-scroll');
        });

        this._elements.$backBtn.on('click', () => {
            this._$rootElement.removeClass(config.classNames.overlayVisible);
            $('html').removeClass('body--no-scroll');
        });

        this._elements.$thanksBtn.on('click', () => {
            this._$rootElement.removeClass(config.classNames.overlayVisible);
            $('html').removeClass('body--no-scroll');
        });

        this._elements.$fullScreenGalleryBtn.on('click', () => {
            this._$rootElement.addClass(config.classNames.fullScreen);
        });

        this._elements.$fullScreenGalleryBtnClose.on('click', () => {
            this._$rootElement.removeClass(config.classNames.fullScreen);
        });

        // eslint-disable-next-line func-names
        this._elements.$openTrigger.on('click keydown', function (e) {
            // eslint-disable-next-line no-console
            if (!isClickOrEnter(e)) {
                return;
            }

            const dataId = $(this).data('overlay-open');
            $(`[data-overlay-id="${dataId}"]`).addClass(config.classNames.overlayVisible);
            $('html').addClass('body--no-scroll');
            if (dataId === 'search') {
                if ($(config.selectors.searchInput)) {
                    $(config.selectors.searchInput).focus();
                    $(config.selectors.searchInput).val('');
                }
            }
        });

        if (this._$rootElement.hasClass(config.classNames.sticky)) {
            this._elements.$wrapper.on('scroll', () => {
                if (this._elements.$wrapper[0].scrollTop === 0) {
                    this._elements.$header.removeClass(config.classNames.stickyHeader);
                } else {
                    this._elements.$header.addClass(config.classNames.stickyHeader);
                }
            });
        }
        
        let keypressed = {};

    
        this._elements.$textAreaBtn.on("keydown", e => {
           

            if(e.which == 9) {
                e.preventDefault();
               $('.overlay--visible .overlay__close-btn').trigger('focus');
            }

            keypressed[e.code] = true;

            if (keypressed['ShiftLeft'] && keypressed['Tab']) {

                let searchinput = $('.overlay--visible .search-bar__text-input')[0];

                $(searchinput).trigger('focus');
            }
        });
        
        this._elements.$closeBtn.on("keydown", e => {
           
            if(e.code == 'Tab') {
                e.preventDefault();
                let searchinput = $('.overlay--visible .search-bar__text-input')[0];
                
                $(searchinput).trigger('focus');
            }

            if(e.code == 'Enter') {
                
               if($(e.currentTarget).closest(config.selectors.root).hasClass('overlay--visible')){
                $(e.currentTarget).closest(config.selectors.root).removeClass('overlay--visible')
                $('html').removeClass('body--no-scroll')
               }
            }

        
        });

        this._elements.$textAreaBtn.on("keyup", e => {
            keypressed[e.code] = false;
        });

        this._elements.$closeBtn.on("keyup", e => {
            keypressed[e.code] = false;
        });
    }

    static setContent($el, html) {
        $el.find(config.selectors.content).html(html);
    }
}

moduleRegistry.registerModule('Overlay', Overlay);
moduleRegistry.autoApplyModule('Overlay', config.selectors.root);
